import type React from 'react';

import { Alert } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { usePromotePageState } from 'src/app/pages/promote/pageContext';

import { useValidationError } from '../../hooks/useValidationError';

export const ValidationError: React.FC = () => {
	const { error } = useValidationError({ type: 'selection' });
	const [{ customAmountSelected }] = usePromotePageState();
	if (!error || customAmountSelected) return null;
	return (
		<Alert
			variant="error"
			heading={<Translate value="corgi.co.promote.validation.amount.not_selected.heading" />}
			data-qa="invalid-amount-error-message"
		>
			<Translate value="corgi.co.promote.validation.amount.not_selected.description" />
		</Alert>
	);
};
